// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".number[data-v-0b07d328]:before{display:block;content:attr(title);font-weight:700;height:0;overflow:hidden;visibility:hidden}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
